/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  CreateIssuerRequestBody,
  CreateIssuerRequestBody$Outbound,
  CreateIssuerRequestBody$outboundSchema,
} from "../components/createissuerrequestbody.js";

export type CreateOrganizationRemoteSessionIssuerSecurity = {
  sessionHeaderGramSession?: string | undefined;
  apikeyHeaderGramKey?: string | undefined;
};

export type CreateOrganizationRemoteSessionIssuerRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  createIssuerRequestBody: CreateIssuerRequestBody;
};

/** @internal */
export type CreateOrganizationRemoteSessionIssuerSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
  "apikey_header_Gram-Key"?: string | undefined;
};

/** @internal */
export const CreateOrganizationRemoteSessionIssuerSecurity$outboundSchema:
  z.ZodMiniType<
    CreateOrganizationRemoteSessionIssuerSecurity$Outbound,
    CreateOrganizationRemoteSessionIssuerSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
      apikeyHeaderGramKey: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
      });
    }),
  );

export function createOrganizationRemoteSessionIssuerSecurityToJSON(
  createOrganizationRemoteSessionIssuerSecurity:
    CreateOrganizationRemoteSessionIssuerSecurity,
): string {
  return JSON.stringify(
    CreateOrganizationRemoteSessionIssuerSecurity$outboundSchema.parse(
      createOrganizationRemoteSessionIssuerSecurity,
    ),
  );
}

/** @internal */
export type CreateOrganizationRemoteSessionIssuerRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  CreateIssuerRequestBody: CreateIssuerRequestBody$Outbound;
};

/** @internal */
export const CreateOrganizationRemoteSessionIssuerRequest$outboundSchema:
  z.ZodMiniType<
    CreateOrganizationRemoteSessionIssuerRequest$Outbound,
    CreateOrganizationRemoteSessionIssuerRequest
  > = z.pipe(
    z.object({
      gramSession: z.optional(z.string()),
      gramKey: z.optional(z.string()),
      createIssuerRequestBody: CreateIssuerRequestBody$outboundSchema,
    }),
    z.transform((v) => {
      return remap$(v, {
        gramSession: "Gram-Session",
        gramKey: "Gram-Key",
        createIssuerRequestBody: "CreateIssuerRequestBody",
      });
    }),
  );

export function createOrganizationRemoteSessionIssuerRequestToJSON(
  createOrganizationRemoteSessionIssuerRequest:
    CreateOrganizationRemoteSessionIssuerRequest,
): string {
  return JSON.stringify(
    CreateOrganizationRemoteSessionIssuerRequest$outboundSchema.parse(
      createOrganizationRemoteSessionIssuerRequest,
    ),
  );
}
